import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons';
import Button from '@material-ui/core/Button';
import { MoreVertRounded } from '@material-ui/icons';
import { NavLink, useHistory } from 'react-router-dom';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Autocomplete from '@material-ui/lab/Autocomplete';
import parse from 'autosuggest-highlight/parse';
import match from 'autosuggest-highlight/match';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import LinearProgress from '@material-ui/core/LinearProgress';
import Tooltip from '@material-ui/core/Tooltip';

import Cookies from 'js-cookie';
import { clearCookie, getPrivileges } from '../../../functions/Auth';
import API_PATH from "../../../constants/config.json";
import ErrorMessage from '../../AppLayouts/ErrorMessage';
import { CircularProgress } from '@material-ui/core';

import { withStyles, makeStyles } from '@material-ui/core/styles';

const axios = require('axios');
const API_URL = process.env.REACT_APP_BASE_URL;
const AWS = require('aws-sdk');

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography component="div">{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function LinearProgressWithLabel(props) {
    return (
      <Box display="flex" alignItems="center">
        <Box width="100%" mr={1}>
          <LinearProgress variant="determinate" {...props} />
        </Box>
        <Box minWidth={35}>
          <Typography variant="body2" color="textSecondary">{`${Math.round(
            props.value,
          )}%`}</Typography>
        </Box>
      </Box>
    );
}

let bcktName;
let uploadRetryCount = 0;
let s3UploadStatus = false;

//Start ImportList component code ...
const ImportList = props => {
    
    let history = useHistory();
    const [activeFileDetails, setActiveFileDetails] = useState([]);
    const [importloaderShow, setImportloaderShow] = useState('none');
    const [importBtnStatus, setImportBtnStatus] = useState(1);
    const [fileToRemove, setFileToRemove] = useState(null);
    const [fileStationIdToRemove, setfileStationIdToRemove] = useState(null);
    const [showActions, setShowActions] = useState(false);
    const [actionsTop, setActionsTop] = useState(0);
    const [actionsLeft, setActionsLeft] = useState(0);
    const [activeLocationSelection, setActiveLocationSelection] = useState(null);
    const [stationsList, setStationsList] = useState([]);
    const [agencyBucket, setAgencyBucket] = useState('');
    const [idintityPool, setIdintityPool] = useState('');
    const [aswLogins, setAswLogins] = useState('');
    const [errPopUp, setErrPopUp] = React.useState(false);
    const [errMsg, setErrMsg] = React.useState(null);
    const [errMsgType, setErrMsgType] = React.useState('error');
    const [msgTitle, setMsgTitle] = useState(null);
    const [scrolled, setScrolled] = useState(false);

    const [progressFiles, setProgressFiles] = useState([]);

    const listFilesRef = useRef();
    

    useEffect(() => {
        if (getPrivileges().length !== 0) {
            getBucket();
            getAswToken();
        }
        setImportBtnStatus(1);
        if(props.details.length > 0) {
            let files = [...props.details];
            files.forEach(function(it) {
                if(it.file_status !== 'success') {
                    setImportBtnStatus(0);
                }
            })
        }
        if(props.geojsonLayer)
            fillStationsList();
        if(props.activeStationIDSel && activeLocationSelection) {
            let allstations = [...props.stationDetails];
            let client_station_id = null;
            allstations.forEach(function(st, ind) {
                if(st.station_id === props.activeStationIDSel){
                    client_station_id = st.stationId;
                }
            });
            if(client_station_id) {
                let tmp = [...props.mapLocation];
                tmp.push({ clent_Station_id: client_station_id });
                props.setMapLocation(tmp);
                props.changeMapView(tmp);
                let tmpdet = [...props.details];
                tmpdet.forEach(function(it, ind) {
                  if(it.uniqueID === activeLocationSelection) {
                    tmpdet[ind].sationId = client_station_id;
                    tmpdet[ind].station_id = props.activeStationIDSel;
                    tmpdet[ind].file_status = 'success';
                  }
                });
                props.setDetails(tmpdet);
                setActiveLocationSelection(null);
            }
        } else {
            props.changeMapView([...props.mapLocation]);
        }
    }, [props.details, props.activeStationIDSel,props.stationDetails])

    const getBucket = () => {
        try {
        axios({
            method: 'post',
            url: API_URL + API_PATH.getAWSs3BucketAPI,
            headers: {
            'agencyid': sessionStorage.getItem('agency_id'),
            'payload': Cookies.get('payload'),
            },
        }).then(async function (response) {
            if (response.status && response.status == '200') {
            bcktName = response.data;
            bcktName = bcktName.data;
            bcktName = bcktName.bucket_name;
            setAgencyBucket(bcktName);
            } else {
            console.log("Do Not Get Any Station ID");
            }
        }).catch(async function (error) {
            if (error.response) {
            if (error.response.status && error.response.status == '401') {
                if (Cookies.get('email')) {
                clearCookie('email');
                clearCookie('payload');
                clearCookie('idToken');
                clearCookie('atexpiry');
                }
                history.push('/');
            }
            }
        })
        } catch (error) {
        console.error(error);
        }
    }

    let aswData;
    const getAswToken = () => {
        try {
        axios({
            method: 'get',
            url: API_URL + API_PATH.getAWSs3TokenAPI,
            headers: {
            'agencyid': sessionStorage.getItem('agency_id'),
            'payload': Cookies.get('payload'),
            },
        }).then(async function (response) {
            if (response.status && response.status == '200') {
            aswData = response.data;
            aswData = aswData.data;
            setIdintityPool(aswData.IdentityPoolId);
            setAswLogins(aswData.Logins);
            } else {
            console.log("Do Not Get Any Station ID");
            }
        }).catch(async function (error) {
            if (error.response) {
            if (error.response.status && error.response.status == '401') {
                if (Cookies.get('email')) {
                clearCookie('email');
                clearCookie('payload');
                clearCookie('idToken');
                clearCookie('atexpiry');
                }
                history.push('/');
            }
            }
        })
        } catch (error) {
        console.error(error);
        }
    }

    function listObjs(bucket) {
        return new Promise((resolve, reject) => {
        let prefix = Cookies.get('email');
        bucket.listObjects({
            Prefix: prefix
        }, function (err, data) {
            if (err) {
            console.log('ERROR: ' + err);
            } else {
            let objKeys = "";
            data.Contents.forEach(function (obj) {
                objKeys = obj.Key;
            });
            resolve(true);
            }
        });
        })
    }

    const fillStationsList = async() => {
        var query = props.geojsonLayer.createQuery();
        query.outFields = ["station_id", "client_station_id", "station_location", "station_type", "latitude", "longitude","display_name", "is_shared", "agency_id", "visible"];
        query.where = "(is_shared = 0 OR (is_shared = 1 AND agency_id != "+sessionStorage.getItem('agency_id')+") AND visible = 1)";
        let results = await props.geojsonLayer.queryFeatures(query).then(function(results){     
            //slice array use to get the first 10 results             
            return results.features.map(function(feature) {
                return {
                    key: "station_location",
                    text: "("+feature.attributes.client_station_id+") "+((feature.attributes.display_name !='')?feature.attributes.display_name : feature.attributes.station_location),
                    searchText : feature.attributes.client_station_id
                };
            });   
        })
        setStationsList(results);
    }

    const handleBack = () => {
        props.setDetails([]);
        props.handleActiveImportFile(false);
        props.setImportFilesListChecked(false);
        props.setMapLocation([]);
        props.changeMapView([]);
        props.passPopValue();
    }

    const handleViewDetails = (fileid) => {
        if(importloaderShow !== 'block') {
            setActiveFileDetails([...activeFileDetails, fileid]);
        }
    }

    const handleHideDetails = (fileid) => {
        let tmpdet = [...activeFileDetails];
        let pos = tmpdet.indexOf(fileid);
        if(pos >= 0) {
            tmpdet.splice(pos, 1);
        }
        setActiveFileDetails(tmpdet);
    }

    const handleShowActions = (e,fileind, stationid) => {
        if(importloaderShow !== 'block') {
            setShowActions(true);
            setFileToRemove(fileind);
            setfileStationIdToRemove(stationid);
            setActionsTop(e.pageY);
            setActionsLeft(e.pageX-112);
        }
    }

    const removeRow = () => {
        let tmpdetails = [...props.details];
        tmpdetails = tmpdetails.filter((row) => row.uniqueID !== fileToRemove);
        props.setDetails(tmpdetails);
        let tmp = [...props.mapLocation];
        let indst = tmp.findIndex( (loc) => loc.clent_Station_id === fileStationIdToRemove);
        if(indst >= 0) {
            tmp.splice(indst, 1);
            props.setMapLocation(tmp);
            props.changeMapView(tmp);
        }
        setShowActions(false);
    }

    const handleClickAway = () => {
        setShowActions(false);
    }
    
    const handleActiveLocationSel = (uniqueid) => {
        setActiveLocationSelection(uniqueid);
    }

    const importFileData = async () => {   
        setErrMsg(null);
        let details = props.details;
        let fileIndex = [];
        let batchIDArray = [];
        let file_ids;
        let OIDToken = Cookies.get('idToken');
        let bucketName = agencyBucket;
        AWS.config.region = 'us-west-2'; // Region
        AWS.config.credentials = new AWS.CognitoIdentityCredentials({
        IdentityPoolId: idintityPool,
        Logins: {
            [aswLogins]: OIDToken
        }
        });

        let bucket = new AWS.S3({
        params: {
            Bucket: bucketName
        }
        });
        setImportloaderShow('block');

        // getting max batch id 
        try {
          //this code is import datafile for import list
          await axios({
            method: 'post',
            url: API_URL + API_PATH.getMaxBatchId,
            headers: {
                'agencyid': sessionStorage.getItem('agency_id'),
                'payload': Cookies.get('payload'),
            },
          }).then(async function (response) {
            if (response.status && response.status == '200') {
              let resp = response.data;
              let maxBatchId = resp.data[0] ? resp.data[0].nextval : null;
              for (let i = 0; i < details.length; i++) {
                //This Code is Used for Data file
                let fileStatusId = details[i].file_status_id;
                let fileTId = details[i].file_type_id;
                let originName = details[i].fileName;
                let sid = details[i].station_id;
                let username = Cookies.get('email');
                let objKey;
                let timeStams = new Date().getTime();
                let fileExe = details[i].file_exe;     
                objKey = username + '/' + details[i].fileName.replace(/(\.[\w\d_-]+)$/i, '_' + timeStams + '$1');
                let params = {
                    Key: objKey,
                    ContentType: details[i].file_exe,
                    Body: details[i].file_body
                };

                await bucket.upload(params, async function (err, data) {             
                    if (err && err.message) {
                        updateProgress(i, 0);
                        setImportloaderShow('none');
                        setErrMsgType('custom_error')
                        setErrMsg('An error has ocurred while trying to upload your data. Please try and upload again.');
                        setMsgTitle('An error ocurred during upload');
                        setErrPopUp(true);
                    } else {
                        s3UploadStatus = true;
                        try {
                            //this code is import datafile for import list
                            await axios({
                            method: 'post',
                            data: {
                                file_status_id: fileStatusId,
                                file_type_id: fileTId,
                                origin_name: originName,
                                base_name: objKey,
                                station_id: sid,
                                username: username,
                                batch_id: maxBatchId,
                                bucket_name: bucketName
                            },
                            url: API_URL + API_PATH.dataFileAPI,
                            headers: {
                                'agencyid': sessionStorage.getItem('agency_id'),
                                'payload': Cookies.get('payload'),
                            },
                            }).then(async function (response) {
                                if (response.status && response.status == '200') {
                                    fileIndex.push(details[i].uniqueID);
                                    file_ids = response.data.file_id;
                                    batchIDArray.push(file_ids);
                                    let restOF = removeUploadedFile(fileIndex);
                                    await listObjs(bucket).then(async result => {
                                        if (restOF === 0) {
                                            setImportloaderShow('none');
                                            props.setMapLocation([]);
                                            if (fileIndex.length > 0) {
                                                if (fileIndex.length === details.length) {
                                                    props.setDetails([]);
                                                    uploadRetryCount = 0;
                                                    s3UploadStatus = false;
                                                    props.changeMapView([]);
                                                    setErrMsgType('custom_success_nb');
                                                    setMsgTitle('Import complete');
                                                    //setErrMsg('Files imported successfully. Check stations to see changes or view data management.');
                                                    setErrMsg('File import has been completed. View data in data management to approve or reject imported files.');
                                                    setErrPopUp(true);
                                                }
                                                else {
                                                    await removeUploadedFile(fileIndex);
                                                    uploadRetryCount = 0;
                                                    s3UploadStatus = false;
                                                }
                                            }
                                        }
                                    }).catch(err => {
                                        console.log(err)
                                    })
                                } else {
                                    console.log("Data file no import");
                                }
                            }).catch(async function (error) {
                                setImportloaderShow('none');
                                setErrMsgType('custom_error')
                                setErrMsg('An error has ocurred while trying to upload your data. Please try and upload again.');
                                setMsgTitle('An error ocurred during upload');
                                setErrPopUp(true);
                                if (error.response) {
                                    if (error.response.status && error.response.status == '401') {
                                    if (Cookies.get('email')) {
                                        clearCookie('email');
                                        clearCookie('payload');
                                        clearCookie('idToken');
                                        clearCookie('atexpiry');
                                    }
                                    history.push('/');
                                    }
                                }
                            })
                        } catch (error) {
                            console.error(error);
                        }
                    }
                }).on("httpUploadProgress", (progress) => {
                    let uploaded = parseInt((progress.loaded * 100) / progress.total);
                    updateProgress(i, uploaded);
                });     
              }
            } else {
              console.log("No batch id returned");
            }
          });
        } catch (error) {
            console.error(error);
        }
    }

    const updateProgress = (ind, progress) => {
        let upFiles= [...props.details];
        upFiles.map( (file,index) => {
            if(index===ind)
                return file.progress = progress;
            return file;
        });
        props.setDetails(upFiles);
    }

    const removeUploadedFile = (fileIndex = []) => {
        let tempArray = [];
        if (fileIndex.length > 0) {
            for (let i = 0; i < props.details.length; i++) {
                let indexFile = fileIndex.findIndex((uniqueID, index) => uniqueID === props.details[i].uniqueID)
                if (indexFile === -1) {
                    tempArray.push(props.details[i]);
                }
            }
            props.setDetails(tempArray);
        }
        return tempArray.length;
    }

    const ShowErrPopUp = () => {
        setErrPopUp(false)
    };

    const handleScroll = () => {
        if (listFilesRef.current) {
          const { scrollTop } = listFilesRef.current;
          if (scrollTop > 0) {
            setScrolled(true);
          } else {
            setScrolled(false);
          }
        }
    };

    const HtmlTooltip = withStyles((theme) => ({
        tooltip: {
            backgroundColor: '#FFFFFF',
            boxShadow: "0px 10px 15px -3px rgba(0, 0, 0, 0.1), 0px 4px 6px -2px rgba(0, 0, 0, 0.05)",
            color: '#27272A',
            maxWidth: 326,
            border: '1px solid #dadde9',
            padding: '12px',
            gap: '12px',
            borderRadius: '6px',
            height:'136px',
            "& a" : {
                color: "#1D4ED8",
                backgroundColor : "transparent",
            },
            "& a:visited" : {
                color: "#1D4ED8",
                backgroundColor : "transparent",
            }
        },
    }))(Tooltip);    

  return (
    <React.Fragment>
      <div className={'panel-import-list'}>
          <div className={scrolled ? "import-header panel-scrolled" :"import-header"}>
            <div className="import-list-header">
                <p className="closeIcon" onClick={handleBack}>
                <FontAwesomeIcon icon={faAngleLeft} className="btnIcons" title='Close' /> <label>Back</label>
                </p>
                <img src={require('../../../assets/icons/import-table.png')} onClick={() => props.setShowImportTable(true)} />
            </div>
            <div className={'results-title-lbl'}> 
                <label className='station-list-lbl'>Data import</label>
            </div>
            <div className="import-list-buttons">
                {
                    importloaderShow === 'block' ? 
                        <Button className="blue-btn font-14" >
                                <CircularProgress />
                        </Button>
                    :
                    <Button className="blue-btn font-14" 
                        disabled={importBtnStatus == 0 || props.details.length == 0 || importloaderShow === 'block' ? true : false}
                        onClick={importFileData}
                    >
                            {errMsg && errMsgType==='custom_error' ? 'Retry import' : 'Import data'}
                    </Button>
                }
                <Button className="cancel-btn" disabled={importloaderShow === 'block' ? true : false}><NavLink to={`/UsersDashboard?import=` + 1}>Add files</NavLink></Button>
            </div>
          </div>
        <div className={importloaderShow === 'block' ? "import-list-files inactive" : "import-list-files"} onScroll={handleScroll} ref={listFilesRef}>
            {errMsg ? <ErrorMessage message={errMsg} title={msgTitle} visible={ShowErrPopUp} show={errPopUp} msgType={errMsgType} dataManager={props.handleOpenDataManager} /> : null}
            {
                props.details.map( function(item,ind) {
                    return <div className="main-card">
                        <div className="card-item">
                            <div className={activeFileDetails.indexOf(item.uniqueID) >= 0 ? "item-filename active" : "item-filename"}>
                                <div className='child-filename'>
                                    {
                                        item.file_status === 'success' && item.file_size_status === 'success' ?
                                        <img src={require('../../../assets/icons/check-import-file.png')} />
                                        :
                                        <img src={require('../../../assets/icons/warning-yellow.png')} />
                                    }
                                    <label>
                                        {item.fileName}
                                    </label>
                                    <MoreVertRounded onClick={(e) => handleShowActions(e,item.uniqueID,item.sationId)} />
                                </div>
                                { ( item.progress ) ? <LinearProgressWithLabel value={item.progress} /> : null }    
                            </div>
                            {
                                activeFileDetails.indexOf(item.uniqueID) >= 0 ?
                                    <div className="file-details">
                                        <div className="table-details">
                                            <p>
                                                <label>Type</label>
                                                <HtmlTooltip interactive
                                                    title={
                                                        (item.dataType) == 'File Storage' ?
                                                        <React.Fragment>
                                                            <label style={{fontSize:'14px', "font-style": "normal", "font-weight": 400, "line-height": "20px", "font-family": "Inter-Regular", "color":"#27272A"}}> This file will be uploaded to storage. If you are trying to upload a raw traffic data file, please make sure the file type is supported for data import. </label>
                                                            <br></br>
                                                            <br></br>
                                                            <label> <a href='https://intercom.help/DataPointApp/en/collections/3288501-import-data' target="_blank" style={{fontSize:'14px',"font-style": "normal", "font-weight": 400, "line-height": "20px", "font-family": "Inter-Regular"}}> File import requirements and best practices </a> </label>
                                                        </React.Fragment>
                                                        : ''
                                                    }
                                                    PopperProps={{
                                                        popperOptions: {
                                                            modifiers: {
                                                                offset: {
                                                                    enabled: true,
                                                                    offset: '40px, 0px',
                                                                },
                                                            },
                                                        },
                                                    }}
                                                >
                                                    <label className={item.dataType == 'File Storage' ? "type-status-storage" : "type-status-import"}>{item.dataType == 'File Storage' ? 'Storage' : 'Import'}</label>
                                                </HtmlTooltip>
                                            </p>
                                            <p className="odd">
                                                <label>Station ID</label>
                                                <div>
                                                    {
                                                        activeLocationSelection === item.uniqueID ?
                                                        <img src={require('../../../assets/icons/active-location.png')}/>
                                                        :
                                                        <img src={require('../../../assets/icons/location.png')} onClick={() => handleActiveLocationSel(item.uniqueID) } style={item.file_size_status === 'error' ? {pointerEvents: 'none', opacity: '0.4'} : null} />
                                                    }
                                                    <Autocomplete
                                                        disabled={item.file_size_status === 'error'}
                                                        value={item.sationId}
                                                        openOnFocus={false}
                                                        onChange={(event, newValue) => {
                                                            // launched when an option is chosen or the clear icon clicked
                                                            let tmpdet = [...props.details];
                                                            tmpdet.forEach(function(it, ind) {
                                                                if(it.uniqueID === item.uniqueID) {
                                                                    let stID = null;
                                                                    let tmp = [...props.mapLocation];
                                                                    if(newValue) {
                                                                        tmp.push({ clent_Station_id: newValue.searchText });
                                                                        let allstations = [...props.stationDetails];
                                                                        allstations.forEach(function(st, ind) {
                                                                            if(st.stationId === newValue.searchText){
                                                                                stID = st.station_id;
                                                                            }
                                                                        });
                                                                    } else {
                                                                        let indst = tmp.findIndex( (loc) => loc.clent_Station_id === it.sationId);
                                                                        tmp.splice(indst, 1);
                                                                    }
                                                                    props.setMapLocation(tmp);
                                                                    props.changeMapView(tmp);
                                                                    tmpdet[ind].sationId = newValue ? newValue.searchText : "";
                                                                    tmpdet[ind].file_status = newValue ? 'success' : 'error';
                                                                    tmpdet[ind].station_id = newValue ? stID : 0;
                                                                    
                                                                }
                                                            });
                                                            props.setDetails(tmpdet);
                                                        }}
                                                        inputValue={item.sationId}
                                                        onInputChange={(event, newInputValue) => {
                                                            // launched when the user ins typing
                                                            let tmpdet = [...props.details];
                                                            if(newInputValue && newInputValue !== '') {
                                                                tmpdet.forEach(function(it, ind) {
                                                                    if(it.uniqueID === item.uniqueID) {
                                                                        tmpdet[ind].sationId = newInputValue;
                                                                    }
                                                                });
                                                            } 
                                                            props.setDetails(tmpdet);
                                                        }}
                                                        options={stationsList}
                                                        getOptionLabel={(option) => option.text}
                                                        PaperComponent={({ children }) => (
                                                            <Paper style={{position: "absolute", right: 0, width: "368px", overflow: "hidden", maxHeight: "270px", boxShadow: "0px 10px 15px -3px rgba(0, 0, 0, 0.1), 0px 4px 6px -2px rgba(0, 0, 0, 0.05)", borderRadius: "6px"}}>{children}</Paper>
                                                        )}
                                                        renderInput={(params) => (
                                                            <TextField {...params} className={item.file_status !== 'success' && "warning-status" } />
                                                        )}
                                                        renderOption={(option, { inputValue }) => {
                                                            const matches = match(option.text, inputValue);
                                                            const parts = parse(option.text, matches);
                                                            return (
                                                            <div>
                                                                {parts.map((part, index) => (
                                                                <span key={index} className="station-item" style={{ fontWeight: part.highlight ? 700 : 400 }}>
                                                                    {part.text}
                                                                </span>
                                                                ))}
                                                            </div>
                                                            );
                                                        }}
                                                    />
                                                </div>
                                            </p>
                                            <p>
                                                <label>Vendor</label>
                                                <label>{item.vendor}</label>
                                            </p>
                                            <p className="odd">
                                                <label>Data type</label>
                                                <label>{item.dataType}</label>
                                            </p>
                                            {
                                                item.file_size_status === 'error' ?
                                                <p className="error-description">
                                                    <img src={require('../../../assets/icons/File-yellow.png')} />
                                                    <label>
                                                        <span>{item.status.title}</span>
                                                        <span>{item.status.description}</span>
                                                    </label>
                                                </p>
                                                : (item.file_status === 'error' && item.status.description) &&
                                                <p className="error-description">
                                                    <img src={require('../../../assets/icons/File-yellow.png')} />
                                                    <label>
                                                        <span></span>
                                                        <span>{item.status.description}</span>
                                                    </label>
                                                </p>
                                            }
                                        </div>
                                        <label className="hide-details" onClick={() => handleHideDetails(item.uniqueID)}>Collapse details</label>
                                    </div>
                                :
                                <label><span onClick={() => handleViewDetails(item.uniqueID)}>View details</span></label>
                            }
                        </div>
                    </div>
                })
            }
        </div>
      </div>
      {
        showActions &&
        <ClickAwayListener onClickAway={handleClickAway}>
        <div className="actions-panel" style={{top: actionsTop+'px', left: actionsLeft+'px'}}>
                <div onClick={removeRow}>
                    <img src={require('../../../assets/icons/import-file-detele.png')} />
                    <label>Delete</label>
                </div>
            </div>
        </ClickAwayListener>
    }
    </React.Fragment>
  );
}

export default ImportList;
//End ImportList component code ...
